/*
 The mobile menu should only be visible on tablets/phones,
 but it's always rendered on the page.
*/
function isMobileMenuVisible() {
  return $('.sticky-mobile-menu').is(':visible');
}
function scrollToTrackerContainerTop() {
  const element = document.getElementById('tracker-container');
  // account for top site navigation menu
  let siteYOffset = 60;
  // account for mobile filter menu
  if (isMobileMenuVisible()) {
    siteYOffset += 45;
  }
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - siteYOffset;
  window.scrollTo({
    top: offsetPosition,
  });
}
/*
 This creates the filter url. The url takes the form
 https://<divesite>/news/<tracker_id>/<id>/?<category1>=<value>&<category2>=<value>.
 This url will automatically filter the tracker by the categories and values if
 they exist on the tracker.
 */
function createFilterURL(params) {
  let param = '';
  const filters = Object.keys(params);
  if (filters.length === 0) {
    return window.location.pathname;
  }

  return filters.reduce((total, key, index) => {
    const startingChar = index === 0 ? '?' : '&';
    param += `${startingChar}${key}=${params[key]}`;
    return param;
  }, '');
}
/*
 Figures out what the current filter state is so the filter url can be constructed.
 */
function getCurrentFilters() {
  // The mobile filter uses <select> while the desktop has its own custom dropdown.
  function getValueFromFilters(isMobile, $dropdown) {
    if (isMobile) {
      const select = $dropdown.children('select');
      return [
        select.attr('name'),
        select.val(),
      ];
    }
    return [
      $dropdown.children('ul').attr('filter_name'),
      $dropdown.find('span.pseudo-input').attr('value'),
    ];
  }
  const filtersObj = {};
  const isMobileView = isMobileMenuVisible();
  const filters = isMobileView ? $('.mobile-filter') : $('.desktop-filter');
  filters.each(function() {
    const [filterName, filterValue] = getValueFromFilters(isMobileView, $(this));
    if (filterValue && filterValue !== 'see-all') {
      filtersObj[filterName] = filterValue;
    }
  });
  return filtersObj;
}
/*
 Update the url with the current filter state so readers/editors can copy the url and share it.
 */
function updateURLWithFilter() {
  const currentFilters = getCurrentFilters();
  const url = createFilterURL(currentFilters);
  window.history.pushState({}, document.title, url);
}
/*
 Parses the query parameters of the url then tries to find a matching label for each parameter.
 And then, click each label to filter by that label.
 */
function autoFilter() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let hasFilter = false;

  for (let i = 0; i < Object.entries(params).length; i += 1) {
    const [category, value] = Object.entries(params)[i];

    // Find the first label input matching the category and value, so it can be clicked.
    const $labelElement = $(`div.filter-label input[name=${category}][label-name=${value}]`).next().first();

    /*
     Calling click when the length is 0 is fine, but since the flag is needed to know if
     the page should auto-scroll or not; I just lumped the two lines together for readability.

     The scenario where a label might not be found is when the category or value was removed or
     changed.
     */
    if ($labelElement.length > 0) {
      hasFilter = true;
      $labelElement.click();
    }
  }

  // Assuming if no label was click then there's no filter, so no need to scroll to the container.
  if (hasFilter) {
    scrollToTrackerContainerTop();
  }
}
/*
 This is a helper function to handle updating the mobile filter UI so,
 it looks like items are selected.
 */
function updateMobileDropdownBackgroundColor(dropdown) {
  if (dropdown.value !== 'see-all') {
    $(dropdown).addClass('non-see-all');
    $(dropdown).removeClass('see-all');
  } else {
    $(dropdown).addClass('see-all');
    $(dropdown).removeClass('non-see-all');
  }
}
/*
 Create a custom filter event. This is mainly to funnel all filter logic into one function, so it's
 centralized in one area.
 */
function callFilterEvent(categoryName, categoryValue, filterType, htmlElement = null) {
  const eventDetails = {
    detail: {
      category: categoryName,
      value: categoryValue,
      type: filterType,
      htmlElement,
    },
  };
  const filterEvent = new CustomEvent('filter-event', eventDetails);
  document.dispatchEvent(filterEvent);
}
/* Update the borders/spacing for the items and ads */
function updateTrackerItemAndAdStyling() {
  const visibleTrackerItems = $('.tracker__item:visible');
  visibleTrackerItems.each(function(index) {
    const nextItem = $(this).closest('.tracker-item-container').next();
    const nextItemIsVisibleAd = nextItem.hasClass('tracker-ad-placement') && nextItem.is(':visible');
    const isLastVisibleItem = visibleTrackerItems.length - 1 === index || nextItemIsVisibleAd;
    // Remove the tracker item's bottom border
    // if the next item is an ad or if the item is the last visible item (if no ad after).
    $(this).toggleClass('remove-bottom-border', nextItemIsVisibleAd || isLastVisibleItem);
  });
}
/*
 We need to move and hide ads based on the number of tracker items currently displayed.
 Ad placement and rearrangement follows the following logic:
 Hybrid 1: place after 2nd entry
 Hybrid 2: place after 6th entry
 Hybrid 3: place after 10th entry
 Additional logic:
 If there are 7-9 entries, only show Hybrid 1 & Hybrid 2
 If there are 3-6 entries, only show Hybrid 1
 If there are 2-1 entries, only show Hybrid 1 at the bottom
*/
function updateAdPlacement() {
  $('.tracker-ad-placement').hide();
  const $visibleTrackerItems = $('.tracker__item:visible');
  const numVisibleItems = $visibleTrackerItems.length;
  /*
    insert ad elements in the correct places and show them
    if there are two or less tracker items then insert only one ad at the bottom
  */
  function insertAndShowAds(numAds, twoOrLess = false) {
    let firstTrackerItemIndex = 1;
    let ad = $(`.tracker-ad-placement[data-priority="${numAds}"]`);
    if (twoOrLess) {
      ad.insertAfter($visibleTrackerItems.last().closest('.tracker-item-container'));
      ad.show();
    } else {
      let i = 1;
      while (i <= numAds) {
        ad = $(`.tracker-ad-placement[data-priority="${i}"]`);
        ad.insertAfter($visibleTrackerItems.eq(firstTrackerItemIndex).closest('.tracker-item-container'));
        ad.show();
        i += 1;
        // we place ads after every 4 tracker items starting after the second item
        firstTrackerItemIndex += 4;
      }
    }
    updateTrackerItemAndAdStyling();
  }
  /* eslint-disable no-undef */
  function refreshAdSpot(spots) {
    const device = window.dfp_visibility;
    if (window.googletag && googletag.apiReady) {
      const hybrid1Slot = device === 'desktop' ? googletag.pubads().getSlots()[1] : googletag.pubads().getSlots()[0];
      const hybrid2Slot = device === 'desktop' ? googletag.pubads().getSlots()[2] : googletag.pubads().getSlots()[1];
      const hybrid3Slot = device === 'desktop' ? googletag.pubads().getSlots()[3] : googletag.pubads().getSlots()[2];

      if (spots === 1) {
        googletag.pubads().refresh([hybrid1Slot]);
      } else if (spots === 2) {
        googletag.pubads().refresh([hybrid1Slot, hybrid2Slot]);
      } else {
        googletag.pubads().refresh([hybrid1Slot, hybrid2Slot, hybrid3Slot]);
      }
    }
  }

  if (numVisibleItems === 0) {
    $('.tracker-ad-placement').hide();
  } else if (numVisibleItems <= 2) {
    insertAndShowAds(1, true);
    refreshAdSpot(1);
  } else if (numVisibleItems >= 3 && numVisibleItems < 6) {
    insertAndShowAds(1);
    refreshAdSpot(1);
  } else if (numVisibleItems >= 6 && numVisibleItems < 10) {
    insertAndShowAds(2);
    refreshAdSpot(2);
  } else {
    insertAndShowAds(3);
    refreshAdSpot(3);
  }
}
/*
 We need to set the width of the tracker items container so that 'no result' display takes up
 the appropriate amount of space. On page load, the current width is taken and this function is
 called with the width as an argument. This is an awkward workaround because this
 doesn't really work if the person makes the page smaller. So, we may need to improve on this.
 */
function updateNoResultsDisplay(width) {
  function changeNoResultsDisplay(hasItems, filterType) {
    if (hasItems) {
      $('.desktop-filter-grid').css('min-width', 'unset');
      $('.no-results').hide();
    } else {
      /*
       The filterType === 'labels' is for the auto filter functionality.
       The auto filter leverages the labels to filter the tracker. So, it's possible
       for the url to have a filter combination where there are no results.
       Normally, the user cannot have 'no results' if they click on the labels.
       */
      if (filterType === 'desktop' || filterType === 'labels') {
        $('.desktop-filter-grid').css('min-width', width);
      }
      $('.no-results').show();
    }
  }
  return changeNoResultsDisplay;
}

/*
 This function updates the desktop UI to make items look like they're selected. This means the
 background color and text color are changed. Also, if the dropdown is longer than a certain
 link than the display value is truncated. If the user select the 'see-all' option (which is
 the category name) then the dropdown is 'unselected'. In other words, the dropdown looks like
 it did on page load.
 */
function updateDesktopFilterUI(clickedLi) {
  const $clickedLi = $(clickedLi);
  const relative = $(clickedLi).parent('ul');

  $clickedLi.siblings().removeClass('selected-item-text');
  $clickedLi.siblings().removeClass('selected-item-color');

  const optionValue = $clickedLi.attr('value');

  let optionText = $clickedLi.text();
  if (optionText.length >= 25) {
    optionText = `${optionText.slice(0, 25)}...`;
  }

  // Update the pseudo-input with text to make it look like it was selected.
  // Add a value attribute so that auto filter knows what value to use in the url.
  $(relative).siblings('label').children('.pseudo-input').text(optionText)
    .attr('value', optionValue);

  $(relative).siblings('input').prop('checked', false);
  $clickedLi.addClass('selected-item-text');
  $clickedLi.addClass('selected-item-color');

  if (optionValue !== 'see-all') {
    $(relative).siblings('.desktop-dropdown').addClass('dropdown-selected');
  } else {
    $(relative).siblings('.desktop-dropdown').removeClass('dropdown-selected');
  }
}
/*
 This is helper function for when a user selects a label. When a user selects a label,
 we need to update the mobile UI accordingly, so that dropdown value matches the selected label.
 */
function updateMobileFilterUI(category, value) {
  const selectElement = $(`.mobile-tracker-filter-menu select[name="${category}"]`);
  const optionValue = selectElement.children(`option[value="${value}"]`).val();
  selectElement.val(optionValue);
  updateMobileDropdownBackgroundColor(selectElement[0]);
}
/*
 A helper method to 'reset' the desktop UI, so that it looks like nothing is selected.
 NOTE: this doesn't actually reset the filter on the tracker items.
 */
function clearDesktopFiltersUI() {
  $('.desktop-filter li[value="see-all"]').each(function() {
    updateDesktopFilterUI(this);
  });
}
/*
 A helper method to 'reset' the mobile UI, so that it looks like nothing is selected.
 NOTE: this doesn't actually reset the filter on the tracker items.
 */
function clearMobileFilterUI() {
  $('.mobile-filter select').each((function() {
    $(this).val('see-all');
    updateMobileDropdownBackgroundColor(this);
  }));
}
/*
 This function is the heart of the file. It controls what tracker items are actually
 seen or hidden based on the selected label values.
 */
function updateAndFilterTrackerItem(filterLabel) {
  function getLabelsOnTracker(labelDiv) {
    // labelDiv is div.filter-label
    // Go through each div.category-container under div.filter-label and
    // store the for attribute value for each label tag in an array and return it
    const labels = [];
    labelDiv.children().each(function() {
      $(this).filter('label').each(function() {
        labels.push($(this).attr('label'));
      });
    });
    return labels;
  }

  function doesTrackerHaveAllChecked(uniqueLabelsChecked, trackerLabels) {
    // uniqueLabelsChecked is a set
    // convert the set to an array to make the comparison easy
    // Check that all items in the trackerLabels array
    // exist in the allCheckedUnique array
    // Essentially check that checked labels on a tracker item
    // are present in the list of all checked labels in the documents
    const allCheckedUnique = Array.from(uniqueLabelsChecked);
    return allCheckedUnique.every((i) => trackerLabels.includes(i));
  }

  // Mark other items as unchecked (this is to make checkboxes behave like radio buttons)
  // because we want one checkbox checked for each .category-container
  // essentially one filter label selected per category
  const checkboxName = $(filterLabel).attr('name');
  const currentLabelName = $(filterLabel).attr('label-name');

  $(`input.filter-label-checkbox:checkbox[name='${checkboxName}']`).not(filterLabel).prop('checked', false);

  // Get all the filter label with the same label-name attribute as the clicked label
  const allLabelsWithSameName = $(`input.filter-label-checkbox:checkbox[label-name=${currentLabelName}]`);

  // Set the "checked" attribute of all the similar labels to the clicked label's "checked"
  // i.e set to check when the clicked label is checked and unchecked otherwise
  allLabelsWithSameName.prop('checked', filterLabel.checked);

  // Create a set to save all the checked labels
  // I chose a set here to make sure we only have unique values
  const uniqueLabelsChecked = new Set();

  // Get all labels with checked attribute and add their 'label-name'
  // to the set
  const allCheckedLabels = $('input.filter-label-checkbox:checkbox:checked');

  allCheckedLabels.each(function() {
    const labelName = $(this).attr('label-name');
    uniqueLabelsChecked.add(labelName);
  });

  // Get all .filter-label divs
  const allTrackerItemsLabels = $('.tracker__item .filter-label');

  // hide all tracker item
  // we hide all items here in order to show just the ones with checked filters
  $('.tracker__item').hide();

  allTrackerItemsLabels.each(function() {
    // Get the list of filter labels list on a tracker item
    // Will return an empty list when there are no filter labels
    const allLabels = getLabelsOnTracker($(this));

    // Check if the current tracker item's checked labels are in the list
    // of unique labels
    if (doesTrackerHaveAllChecked(uniqueLabelsChecked, allLabels)) {
      // If a tracker item's checked labels are in the list of the unique checked labels,
      // then show that tracker item
      $(this).parent().closest('.tracker__item').show();
    }
  });
}
function clearLabelFilters() {
  /*
   To clear the labels, we need a distinct list of categories. This isn't easy to figure out
   given the current html structure. But, we leverage the fact that the desktop filter UI is
   an easy-ish to get a list of categories. So, we loop through the categories, grab all the
   labels for that category, mark them all as false, and then send a filter event. We just send
   one label as that's what the updateAndFilterTrackerItem function is expecting.

   NOTE: This is assuming the desktop and mobile UI are both rendered regardless of device
   the user is using. At the time of writing, we don't really have a way to know which device
   the user is on, so usually render both the mobile and desktop UIs.
   */
  $('.desktop-filter ul').each(function() {
    const filterName = $(this).attr('filter_name');
    const labels = $(`input[name="${filterName}"]`);
    labels.prop('checked', false);
    callFilterEvent(filterName, $(labels[0]).val(), 'labels', labels[0]);
  });
}

function toggleClearDesktopFiltersLink() {
  // This shows the 'Clear' link on desktop if any filters have been selected and hides it
  // otherwise. We show the link if any 'see-all' options are not selected - which means
  // a filter has been chosen.
  const notSelectedSeeAllOptions = $('.desktop-filter').find('li[value="see-all"]').filter(':not(.selected-item-text)');
  $('.clear-desktop-filters').toggleClass('hide-large', notSelectedSeeAllOptions.length === 0);
}

/*
 This handles filtering tracker items by labels. If a user clicks on a label, we send
 a filter event for that label.
 */
$('input.filter-label-checkbox:checkbox').change(function() {
  const filterName = $(this).prop('name');
  const filterValue = $(this).attr('label-name');
  callFilterEvent(filterName, filterValue, 'labels', this);
  toggleClearDesktopFiltersLink();
});
/*
 This is a custom event that handles filter. It takes an event that's assumed to have
 a category, the filter value, a type (desktop, mobile, or label), and a html element.
 Depending on the type, the html element could be a li element (the desktop dropdown option),
 an option html element (the mobile dropdown option
 */
document.addEventListener('filter-event', (e) => {
  const {
    category, value, type, htmlElement,
  } = e.detail;

  /*
   This block handles the logic around the desktop and mobile dropdowns. I want to keep them
   together as they are pretty similar, but due to one being a custom dropdown and the other
   being a system dropdown; the logic is a little different in certain cases.
   */
  if (value === 'see-all' && type === 'desktop') {
    const categoryLabels = $(`input[name="${category}"]`);
    categoryLabels.prop('checked', false);
    updateAndFilterTrackerItem(categoryLabels[0]);
  } else if (value === 'see-all' && type === 'mobile') {
    $(htmlElement).val(value);
    updateMobileDropdownBackgroundColor(htmlElement);
    const categoryLabels = $(`input[name="${category}"]`);
    categoryLabels.prop('checked', false);
    updateAndFilterTrackerItem(categoryLabels[0]);
  } else if (type === 'desktop' || type === 'mobile') {
    const labelInput = $(`input[label-name=${value}]:checkbox`)[0];
    $(labelInput).prop('checked', true);
    updateAndFilterTrackerItem(labelInput);
  }

  /*
   Intentionally, keeping this separated from the desktop and mobile if blocks as labels' logic is
   pretty different from it and I think it's a little easier to read.
   */
  if (type === 'labels') {
    updateAndFilterTrackerItem(htmlElement);
    if ($(htmlElement).prop('checked')) {
      const liElement = $(`ul[filter_name="${category}"] li[value="${value}"]`);
      updateDesktopFilterUI(liElement);
      updateMobileFilterUI(category, value);
    } else {
      const liElement = $(`ul[filter_name="${category}"] li[value="see-all"]`);
      updateDesktopFilterUI(liElement);
      updateMobileFilterUI(category, 'see-all');
    }
  }
  updateAdPlacement();
  updateURLWithFilter();
  window.updateNoResultsDisplay(!!$('.tracker__item:visible').length, type);
  scrollToTrackerContainerTop();
});
/*
 This is the click event for the desktop dropdown filter. The dropdown is a custom one
 using li elements as option elements. On click, we immediately filter the tracker items
 unlike the mobile filter.
*/
$('.desktop-dropdown-container li').click(function() {
  const $clickedLi = $(this);
  const filterName = $clickedLi.parent().attr('filter_name');
  /*
   Order matters. Need the UI to be updated before the filter event is called because
   the url is updated to match the current filter in the filter event. And, the event
   relies on desktop filter UI to figure out what was actually filtered.
   */
  updateDesktopFilterUI(this);
  callFilterEvent(filterName, $clickedLi.attr('value'), 'desktop');
  toggleClearDesktopFiltersLink();
});
/*
 When the user opens the dropdown again, the selected items background color and text is different,
 so they know which item they selected. However, once they enter the dropdown, we want to remove
 the background color, but keep the bolded text.
 */
$('.desktop-dropdown-container').hover(function() {
  if ($(this).siblings('input').prop('checked')) {
    $(this).children('li').removeClass('selected-item-color');
  }
});
// Close the other opened dropdown if you try to open another dropdown.
$('.desktop-dropdown').click(function() {
  const nextDropdownInput = $(this).siblings('input');
  $('.desktop-dropdown-input').not(nextDropdownInput).prop('checked', false);
});
/*
 Clear the filters for the desktop filters, mobile filters, and no-results display
 */
$('.clear-filters').click((event) => {
  event.preventDefault();
  clearDesktopFiltersUI();
  clearMobileFilterUI();
  clearLabelFilters();
  $('.clear-desktop-filters').addClass('hide-large'); // hides the 'Clear' filters link on desktop
  updateAdPlacement();
  updateURLWithFilter();
});
/*
 We need this event because we want to update the dropdown UI on selection, but we don't want
 to filter until the user clicks on the filter button.
 */
$('.mobile-filter select').change((function() {
  updateMobileDropdownBackgroundColor(this);
}));
/*
 This is for when the user clicks on the menu, we don't want the event to propagate to the html.
 That would trigger the menu to close. So the menu would never open in that case.
 */
$('.sticky-mobile-menu').click(((event) => {
  event.stopPropagation();
}));
// A helper event to close the filter menus when the user clicks outside the mobile/desktop menu.
$('html').click(((event) => {
  $('#show-mobile-filter').prop('checked', false);

  /*
   This event only handles if one clicks outside a dropdown area. There's logic else where
   that handles opening and closing other dropdowns when you click inside a dropdown area.
   We only want to close all the dropdowns if the clicked element is not a part of a
   desktop filter. Each desktop dropdown is composed a different html elements that are clickable,
   so we need to check if those elements are a part of a desktop filter.
   */
  const clickedElement = $(event.target);
  const isDesktopFilter = !!(clickedElement.parent('.desktop-filter').length || clickedElement.parent('.desktop-dropdown').length);
  if (!isDesktopFilter) {
    $('.desktop-filter input').prop('checked', false);
  }
}));
/*
 The mobile UI filter is unique in that it has a button you need to click so that the
 filter is actually applied.
 */
$('#save-mobile-filter').click(() => {
  $('.mobile-tracker-filter-menu select').each(function() {
    callFilterEvent($(this).prop('name'), $(this).val(), 'mobile', this);
  });
  // Hide the mobile filter when the user hits the button.
  $('#show-mobile-filter').prop('checked', false);
  // finally track event in google analytics
});

/*
 This is help handle the display for the no results display. At the time of writing this,
 the tracker items don't have a fixed content width. This causes an issue when we have
 no tracker items to display because the 'no results' display is small and the ui shrinks.
 We need to set a width so that the 'no results' display shows up properly. So, we need
 to find the width on the time of load and then 'save' that value.
 */
window.updateNoResultsDisplay = updateNoResultsDisplay($('.desktop-filter-grid').width());
// Checks the url for query parameters and tries to filter the tracker based on the values.
autoFilter();
updateTrackerItemAndAdStyling();
